module.exports = __webpack_public_path__ + "static/four-cover-ea6365ee9745e149d7fcdab644508690.jpg";